// ============================================================================
// Beta-Wasserzeichen (R6-02-d).
// ----------------------------------------------------------------------------
// Rendert NUR, wenn gerade wirklich das Beta-Bundle laeuft (runningEnv() —
// nicht der Wunsch ff_env). Sonst behauptete die App „Beta", waehrend noch
// Prod-Code laeuft. Gilt auch im Web-Beta (beta.lorath.eu im Browser):
// Screenshots aus dem Browser sind genauso oft die Grundlage von Rueckmeldungen.
// ============================================================================

import { createPortal } from 'react-dom';
import { runningEnv } from '../env/appEnv';
import { useT } from '../i18n';
import styles from './BetaWatermark.module.css';

// Genug Kacheln, um auch grosse Fensterbreiten im gedrehten Raster zu fuellen.
const TILE_COUNT = 60;

export function BetaWatermark() {
  const { t } = useT();

  if (runningEnv() !== 'beta') return null;
  if (typeof document === 'undefined') return null;

  const label = t('beta.watermark');

  return createPortal(
    <div className={styles.watermark} aria-hidden="true" data-beta-watermark="true">
      <div className={styles.grid}>
        {Array.from({ length: TILE_COUNT }, (_, index) => (
          <span key={index} className={styles.tile}>{label}</span>
        ))}
      </div>
    </div>,
    document.body,
  );
}
